<template>
    <div class="main">
        <download-Popup></download-Popup>
        <p class="operamini-tips" v-if="isOperamini">In order to give you a better experience, please download our
            professional APP.</p>
        <downloadheader v-show="downLoadHeaderShow" id="headwrap"></downloadheader>
        <navVue :subtitleData="getStatsSubTabList" :navSelected="currentNavTag"
                :isThirdTit='true' :loadingShowProp='getStatsLoadingShow'></navVue>
        <div class="contentWrap" id="contentWrap" style="min-height:35rem;">
            <loading v-if="getStatsLoadingShow" :statsLoading="true"></loading>
            <nodata v-if="getStatsNoDataMode && !getStatsLoadingShow" :whiteMode="false"></nodata>
            <tables v-if="thirdTitChoose === 'Table' && !getStatsNoDataMode && !getStatsLoadingShow"
                    :tableData="getCurrentStatsListData"
                    :noDataModeObj="getStatsNoDataMode">
            </tables>
            <goals v-if="thirdTitChoose === 'Goals' && !getStatsNoDataMode && !getStatsLoadingShow"
                   :goalData="getCurrentStatsListData"
                   :noDataModeShow="getStatsNoDataMode">
            </goals>
            <assists v-if="thirdTitChoose === 'Assists'  && !getStatsNoDataMode && !getStatsLoadingShow"
                     :assistsData="getCurrentStatsListData"
                     :noDataModeShow="getStatsNoDataMode">
            </assists>
            <fixtures v-if="thirdTitChoose ==='Fixtures'  && !getStatsNoDataMode && !getStatsLoadingShow"
                      :fixtures="getCurrentStatsListData"
                      :noDataModeShow="getStatsNoDataMode">
            </fixtures>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from 'vuex';
    import navVue from '@/components/navNew.vue';
    import loading from '@/components/loading.vue';
    import nodata from '@/components/nodata.vue';
    import downloadheader from '@/components/downloadHeader.vue';
    import downloadfooter from '@/components/downloadFooter.vue';
    import assists from '@/components/assists.vue';
    import goals from '@/components/goals.vue';
    import fixtures from '@/components/fixtures.vue';
    import tables from '@/components/table.vue';
    import downloadPopup from '@/components/downloadPopup.vue';
    // import axios from 'axios';

    export default {
        name: 'home',
        data () {
            return {
                currentNavTag: 'STATS',
                downLoadHeaderShow: true,
                scrollLeft: 0, // 记录滚动条长度
                leftToScreen: 0, // 点击元素距离屏幕左侧距离
                rightToScreen: 0, // 点击元素距离屏幕右侧距离
                subtitle: '',
                scroll: 0,
                isOperamini: false
                // subtitChoose: '',
                // subtitData: [],
                // initEntranceUrl: '/m/app/global/2/m.json?plat=m&menu=stats', // 当前链接为最初始二级子标题（标题名及其下的数据链接）链接；
                // initEntranceUrl:'m/app/global/2/m.json?plat=m&menu=stats',
                // thirdTotalTitle: [],
                // thirdTitleUrl: [],
                // thirdTitChoose: '',
                // thirdTitChooseUrl: '',
                // thirdTotalTitInfor: [],
                // currentTableData: [],
                // currentGoalsData: [],
                // currentAssistsData: [],
                // currentFixturesData: [],
                // tabTag: true,
                // goalTag: true,
                // assTag: true,
                // fixtureTag: false,
                // loadingShow: true,
                // noDataMode: false,
            };
        },
        computed: {
            ...mapGetters([
                'getStatsSubTabList',
                'getStatsNoDataMode',
                'getStatsLoadingShow',
                'getCurrentStatsListData',
                'getSubtitChoose'
            ]),
            subtitChoose () {
                return this.$store.state.navStore.subtitChoose;
            },
            thirdTitChoose () {
                return this.$store.state.navStore.thirdTitChoose;
            }
        },
        asyncData ({ store, route: { params: { subtitle } } }) {
            let allFetch = async () => {
                let menus = await store.dispatch('menusListApi', { subtitle, type: 'STATS' });
                const chooseArr = store.getters.getStatsSubTabList.filter(ele => {
                    return ele.label === store.state.navStore.subtitChoose;
                });
                const urlApi = (chooseArr && chooseArr.length && chooseArr[0].urlApi[0].url) || '';
                let statsList = await store.dispatch('statsListApi', { urlApi });
                return Promise.all([
                    menus,
                    statsList
                ]);
            };
            return allFetch();
        },
        created: function () {
            // this.initSubtitle();
        },
        mounted: function () {
            let that = this;
            this.updateTitle();
            window.scrollTo(0, 0);
            window.addEventListener('scroll', onScroll, false);

            function onScroll () {
                that.stickyFn();
                if (that.thirdTitChoose === 'Fixtures') {
                    return;
                }
                that.chooseId_ClassName();
            }

            let utilObj = require('@/util/util.js');
            utilObj.timeForInOut();
            this.isOperamini = utilObj.checkOperamini();
        },
        updated: function () {
            this.chooseId_ClassName();
            this.updateTitle();
        },
        methods: {
            chooseId_ClassName: function () {
                let idClass = [];
                if (this.thirdTitChoose === 'Table') {
                    idClass = ['tablesWrap', 'teamCompete_icon'];
                } else if (this.thirdTitChoose === 'Goals') {
                    idClass = ['goalsWrap', 'goals_avarta'];
                } else if (this.thirdTitChoose === 'Assists') {
                    idClass = ['assistsWrap', 'assist_avarta'];
                }
                let utilObj = require('@/util/util.js');
                utilObj.lazyload(idClass[0], idClass[1]);
            },
            stickyFn: function (ev) {
                window.browers = {};
                let ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                if (browers.Android) {
                    let topFixedWrap = document.getElementById('topFixedWrap');
                    if (!topFixedWrap) {
                        return;
                    }
                    let topFixedWrapHeight = topFixedWrap.offsetHeight; // 被定住的位置的高度
                    this.scroll = document.body.scrollTop;
                    let headwrap = document.getElementById('headwrap');
                    if (!headwrap) {
                        return;
                    }
                    let headHeight = headwrap.offsetHeight; // 下载条的高度
                    let contentWrap = document.getElementById('contentWrap'); // 每个二级导航下的列表内容
                    if (!contentWrap) {
                        return;
                    }
                    if (this.scroll >= headHeight) {
                        topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                        contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                    } else {
                        topFixedWrap.className = 'topFixedWrap';
                        contentWrap.style.paddingTop = 0 + 'px';
                    }
                }
            },
            // initSubtitle: function () {
            //     axios.get(global.apiDomain + this.initEntranceUrl).then((res) => {
            //         // 获取二级导航以及默认页面数据
            //         let alldata = res.data.menus.ranking;
            //         // 获取news下的子标题文案以及对应的数据url，如headline下的数据url
            //         alldata.forEach((e, index) => {
            //             let dataSubtit = { 'label': e.label, 'urlApi': e.sub_tabs };
            //             this.subtitData.push(dataSubtit);
            //         });
            //         console.log('this.subtitData---', this.subtitData);
            //     });
            // },
            // getDataFromThirdUrl: function (url) {
            //     let that = this;
            //     axios.get(global.apiDomain + url).then(res => {
            //         console.log('res:');
            //         console.log(res);
            //         console.log(that.thirdTitChoose);
            //         if (that.thirdTitChoose === 'Table') {
            //             console.log('杯赛联赛返回数据：');
            //             console.log(res.data.content.rounds);
            //             if (typeof res.data.content.rounds == 'undefined' || res.data.content.rounds.length === 0) {
            //                 console.log('这个标签没有数据！');
            //                 that.loadingShow = false;
            //                 that.noDataMode = true;
            //             } else {
            //                 that.noDataMode = false;
            //             }
            //             that.tabTag = true;
            //             that.goalTag = false;
            //             that.assTag = false;
            //             that.fixtureTag = false;
            //             // Vue.set(that,'currentTableData',res.data.content.rounds);
            //             this.currentTableData = res.data.content.rounds;
            //             this.putLocalTimeToData(res.data.content.rounds);
            //
            //             console.log(this.currentTableData);
            //             this.loadingShow = false;
            //         } else if (that.thirdTitChoose == 'Goals') {
            //             let Goals = {
            //                 'header': res.data.content.header,
            //                 'content': res.data.content.data,
            //                 'top': res.data.content.top,
            //                 'end': res.data.content.end,
            //             };
            //             // Vue.set(that,'currentGoalsData',Goals);
            //             this.currentGoalsData = Goals;
            //             console.log('000');
            //             console.log(that.currentGoalsData);
            //             console.log(typeof that.currentGoalsData.content == 'undefined' || that.currentGoalsData.content == 0);
            //             if (typeof this.currentGoalsData.content == 'undefined' || this.currentGoalsData.content == 0) {
            //                 that.loadingShow = false;
            //                 that.noDataMode = true;
            //             } else {
            //                 that.noDataMode = false;
            //             }
            //             that.goalTag = true;
            //             that.tabTag = false;
            //             that.assTag = false;
            //             that.fixtureTag = false;
            //             that.loadingShow = false;
            //         } else if (that.thirdTitChoose == 'Assists') {
            //             let assist = {
            //                 'header': res.data.content.header,
            //                 'content': res.data.content.data,
            //                 'top': res.data.content.top,
            //                 'end': res.data.content.end,
            //             };
            //             // Vue.set(that,'currentAssistsData',assist);
            //             this.currentAssistsData = assist;
            //             if (typeof this.currentAssistsData.content == 'undefined' || this.currentAssistsData.content == 0) {
            //                 that.loadingShow = false;
            //                 that.noDataMode = true;
            //             } else {
            //                 that.noDataMode = false;
            //             }
            //             that.assTag = true;
            //             that.tabTag = false;
            //             that.goalTag = false;
            //             that.fixtureTag = false;
            //             console.log('that.currentAssistsData:');
            //             console.log(that.currentAssistsData);
            //             this.loadingShow = false;
            //         } else if (that.thirdTitChoose == 'Fixtures') {
            //             console.log('res:');
            //             console.log(res);
            //             // Vue.set(that,'currentFixturesData',res.data.content);
            //             this.currentFixturesData = res.data.content;
            //             if (typeof this.currentFixturesData.matches == 'undefined' || this.currentFixturesData.matches == 0) {
            //                 that.loadingShow = false;
            //                 that.noDataMode = true;
            //             } else {
            //                 that.noDataMode = false;
            //             }
            //             console.log(that.currentFixturesData);
            //             that.fixtureTag = true;
            //             that.tabTag = false;
            //             that.goalTag = false;
            //             that.assTag = false;
            //             this.loadingShow = false;
            //         }
            //     }, res => {
            //         // error callback
            //         that.noDataMode = true;
            //         this.loadingShow = false;
            //     });
            // },
            // putLocalTimeToData: function (dataToTransfer) {
            //     let that = this;
            //     if (dataToTransfer) {
            //         dataToTransfer.forEach(function (elem, index) {
            //             if (elem.template == 'team_point_ranking_match') {
            //                 elem.content.data.forEach(function (e, i) {
            //                     if (e.start_play) {
            //                         let dateTime = e.start_play;
            //                         e.finalIneedTime = that.formatDate(dateTime);
            //                     }
            //                 });
            //             } else if (elem.template == 'team_point_ranking_aggregate') {
            //                 elem.content.data.forEach(function (e, i) {
            //                     if (e.match1.start_play) {
            //                         let dateTime = e.match1.start_play;
            //                         e.match1.finalIneedTime = that.formatDate(dateTime);
            //                     }
            //                     if (e.match2.start_play) {
            //                         let dateTime1 = e.match2.start_play;
            //                         e.match2.finalIneedTime = that.formatDate(dateTime1);
            //                     }
            //                 });
            //             } else if (elem.template == 'team_point_ranking_group') {
            //                 //handle
            //             } else if (elem.template == 'team_point_ranking_regular') {
            //                 //handle
            //             }
            //         });
            //     }
            // },
            // formatDate: function (gmtDate) {
            //     console.log('initial utc data:' + gmtDate); // 2017-08-12 14:00:00
            //     let date = new Date(gmtDate.replace(/-/g, '/')).getTime(); // 获取UTC时间戳
            //     let diff_min = new Date().getTimezoneOffset(); // 返回UTC时间和当前计算机上的时间之间相差的分钟数。utc-当地=差分钟数;
            //     let local_date = new Date(date - diff_min * 60 * 1000); // 获取当地时间
            //     // console.log("local_date:"+local_date);//Sat Aug 12 2017 22:00:00 GMT+0800 (+08)
            //     let local_month = local_date.getMonth() + 1;
            //     local_month = this.dateToDubble(local_month);
            //     let local_timeDetail = ('' + local_date).split(' ');
            //     let local_md_hm = local_month + '-' + local_timeDetail[2] + ' ' + local_timeDetail[4].split(':')[0] + ':' + local_timeDetail[4].split(':')[1];
            //     // console.log("finalTime_md_hm:"+local_md_hm);
            //     return {
            //         finalTime_md_hm: local_md_hm,
            //     };
            // },
            // dateToDubble: function (str) {
            //     if (str < 10) {
            //         return '0' + str;
            //     } else {
            //         return str;
            //     }
            // },
            // updateDatalist: function (url) {
            //     // 子组件navVue向本组件通信 - 点击副导航 -> 更新数据列表
            //     this.getDataFromThirdUrl(url);
            // },
            // updateSubNav: function (data) {
            //     // 子组件navVue向本组件通信 - 初始化副导航展示
            //     this.loadingShow = data.loadingShowObj;
            //     this.noDataMode = data.noDataModeObj;
            //     this.tabTag = data.tabTagObj;
            //     this.goalTag = data.goalTagObj;
            //     this.assTag = data.assTagObj;
            //     this.fixtureTag = data.fixtureTagObj;
            //     this.subtitChoose = data.subtitChooseObj;
            //     this.thirdTitChoose = data.thirdTitChooseObj;
            //     this.getDataUrlApi = data.getDataUrlApiObj;
            //     // 副导航更新后更新新闻列表
            //     this.updateDatalist(this.getDataUrlApi);
            //     this.updateTitle();
            // },
            // updateThirdNav: function (data) {
            //     this.loadingShow = data.loadingShowObj;
            //     this.noDataMode = data.noDataModeObj;
            //     this.tabTag = data.tabTagObj;
            //     this.goalTag = data.goalTagObj;
            //     this.assTag = data.assTagObj;
            //     this.fixtureTag = data.fixtureTagObj;
            //     this.thirdTitChooseUrl = data.thirdTitChooseUrl;
            //     this.thirdTitChoose = data.thirdTitChooseObj;
            //     this.updateDatalist(this.thirdTitChooseUrl);
            //     this.updateTitle();
            // },
            updateTitle: function () {
                document.title = 'All Football - ' + this.subtitChoose + ' ' + this.thirdTitChoose + ' Live Scores, News, Videos & Highlights';
            }
        },
        components: {
            downloadheader, downloadfooter, assists, goals, fixtures, tables, navVue, loading, nodata, downloadPopup
        }
    };
</script>
<style lang="less" scoped>
    .main {
        background: #333d46;
    }

    .topFixedWrap {
        width: 100%;
        background: #262e35;
        z-index: 1000;
    }

    #topFixedWrap {
        z-index: 1000;
    }

    //Android
    .main > .tab-box-fixed {
        position: fixed !important;
        z-index: 10;
        top: 0;
        left: 0;
    }

    .main > .tab-box-testFix {
        z-index: 10;
        top: 0;
        left: 0;
    }

    //iOS
    .tab-box-sticky {
        position: -webkit-sticky;
        position: -moz-sticky;
        position: -ms-sticky;
        position: -o-sticky;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .tab-box-sticky-thrid {
        /*top:3rem;*/
    }

    #contentWrap {
        position: relative;
        z-index: 0;
        padding-top: 0px;
        // min-height:45rem;
    }

    .contentWrap .loadwrap {
        background: #333d46;
    }

    .normal-mode-tip {
        background: #fff;
    }

    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// AppStats.vue?d00baa84